import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import MindsetsJsSDK, {LoadingAction, LoadChallengeCodeAction} from "mindsets-js-sdk";

import PDFViewer from '../common/PDFViewer';
import GeneralError from "../pages/GeneralError";
import useAuth from "../hooks/useAuth";

export default function ({bonus = false}) {
    useAuth(true);

    const params = useParams();
    const dispatch = useDispatch();
    const me = useSelector(state => state.me);
    const challenge_code = useSelector(state => state.challenge_code);
    const [failed, setFailed] = useState(false);
    const [message, setMessage] = useState('Challenge not found.');
    const [data, setData] = useState(null);

    function renderError() {
        if (failed === true) {
            return <GeneralError content={message}/>;
        }

        return null;
    }

    function renderContent() {
        if (data) {
            return (
                <PDFViewer
                    url={data}
                    fileName={challenge_code.latest_challenge_version_name + ' answer key' + (bonus ? ' bonus' : '') + '.pdf'}/>
            );
        }

        return null;
    }

    useEffect(() => {
        dispatch(LoadChallengeCodeAction(params.challenge_code, {'selectors[0]': 'latest_challenge_version_name'}))
            .then(() => MindsetsJsSDK().API.get(`challenge_versions/${params.challenge_code}/answer-key`, {
                buffer: true,
                bonus: bonus ? 'true' : 'false'
            }))
            .then(buffer => setData(buffer))
            .catch(error => {
                setMessage(error);
                setFailed(true);
            })
            .then(() => dispatch(LoadingAction(false)));
    }, []);

    if (!challenge_code || !me) {
        return null;
    }

    return (
        <>
            {renderError()}
            {renderContent()}
        </>
    );
}